
import crud from "./_crud";
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('client_payment_condition', 'la condicion de pago', 'las condiciones de pago');

const importClientPaymentConditions = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_payment_condition/import_payment_conditions`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agregaron las condiciones de pago correctamente.`,
		})
		showSuccessMessage('Se registraron las condiciones de pago correctamente')
		return res.body
	}
}

export default {...actions, importClientPaymentConditions}